import { CadFeatureMap, EventPanelMetadata } from '@mark43/cad-api';
import { IconNameT } from '@cad-arc';

export type FrEventDetailsTab =
    | 'EVENT_INFO'
    | 'NARRATIVE'
    | 'RELATED_DATA'
    | 'MEDIA_ATTACHMENTS'
    | 'EVENT_LOG'
    | 'DEX'
    | 'MERGED_EVENTS';

export type FrEventDetailsTabConfig = {
    name: string;
    type: FrEventDetailsTab;
    icon: IconNameT;
    component: React.FC;
    checkEnabled?: (enabledFeatures: CadFeatureMap, eventMetadata?: EventPanelMetadata) => boolean;
};

export enum ChangeViewDisplayName {
    PrimaryDisposition = 'Primary Disposition',
    AdditionalDisposition = 'Additional Disposition',
    Comments = 'Comments',
    ReactivatedReason = 'Reactivated Reason',
}
